/**
 * Passwortfeld mit Augen-Toggle (open/closed-SVG) — 1:1 zur Web-App.
 * Klick schaltet type password↔text, tauscht das Auge-Icon und aria-label/title.
 */
import { useEffect, useRef, useState } from "preact/hooks";

interface Props {
  id?: string;
  value: string;
  onInput: (value: string) => void;
  placeholder?: string;
  autocomplete?: string;
  minLength?: number;
  required?: boolean;
  error?: boolean;
  autoFocus?: boolean;
}

export function PasswordField({
  id,
  value,
  onInput,
  placeholder = "••••••••",
  autocomplete = "current-password",
  minLength,
  required,
  error,
  autoFocus,
}: Props) {
  const [visible, setVisible] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus) inputRef.current?.focus();
  }, []);
  return (
    <span class="password-field">
      <input
        ref={inputRef}
        id={id}
        type={visible ? "text" : "password"}
        class={error ? "input-error" : undefined}
        placeholder={placeholder}
        autocomplete={autocomplete}
        minLength={minLength}
        required={required}
        value={value}
        onInput={(e) => onInput((e.target as HTMLInputElement).value)}
      />
      <button
        type="button"
        class={`password-toggle${visible ? " is-visible" : ""}`}
        aria-label={visible ? "Passwort verbergen" : "Passwort anzeigen"}
        title={visible ? "Passwort verbergen" : "Passwort anzeigen"}
        onClick={() => {
          setVisible((v) => !v);
          inputRef.current?.focus();
        }}
      >
        <svg class="eye-open" aria-hidden="true" viewBox="0 0 24 24">
          <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <svg class="eye-closed" aria-hidden="true" viewBox="0 0 24 24">
          <path d="M3 3l18 18" />
          <path d="M10.6 10.6A3 3 0 0 0 13.4 13.4" />
          <path d="M8.5 5.8A10.7 10.7 0 0 1 12 5c6 0 9.5 7 9.5 7a17 17 0 0 1-2.1 2.9" />
          <path d="M6.1 7.6A17.2 17.2 0 0 0 2.5 12s3.5 7 9.5 7a10.8 10.8 0 0 0 5-1.2" />
        </svg>
      </button>
    </span>
  );
}
